module.exports = __webpack_public_path__ + "media/amenities.a68034d2.png";